import React, {Component} from "react";
import {Modal, ModalBody, ModalHeader,} from "reactstrap";
import {TipComponent} from "../../Video";

export default class TipListModal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Modal isOpen={this.props.showTipListModalFlag}
                   toggle={() => this.props.hideTipListModal()}
                   centered
                   className="w-md-100 w-sm-100" style={{width: 400}}>
                <ModalHeader
                    toggle={() => this.props.hideTipListModal()}
                    style={{
                        borderBottom: "1px solid #dee2e6",
                        color: "#58595B",
                        fontFamily: "Open Sans",
                        fontSize: "16px !important",
                        fontWeight: "600",
                        letterSpacing: "0",
                        lineHeight: "22px",
                    }}
                >
                    Likes
                </ModalHeader>
                <ModalBody className="w-100">
                    <TipComponent tip={this.props.tip} />
                </ModalBody>
            </Modal>
        );
    }
}
